import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'NiboDate' })
export class DateValuePipe implements PipeTransform {
  transform(value: string | Date): string {
    const d = new Date(value);
    d.setUTCHours(5);
    return d.toLocaleDateString('pt-BR');
  }
}

@Pipe({ name: 'dateWithTime' })
export class DateWitTimeValuePipe implements PipeTransform {
  transform(value: string): string {
    return new Date(value).toLocaleDateString('pt-BR') + ' ' + new Date(value).toLocaleTimeString('pt-BR');
  }
}

@Pipe({ name: 'time' })
export class TimeValuePipe implements PipeTransform {
  transform(value: string): string {
    return new Date(value).toLocaleTimeString('pt-BR');
  }
}
